const TopPlayerCard = ({ playerData = null, playerType = null }) => {
  const player = playerData[0];
  const isPurple = playerType === "purple_cap" ? true : false;
  const isFielding = playerType === "fielding" ? true : false;
  const isOrange = playerType === "orange_cap";

  return (
    <div className="w-full">
      <div className="relative w-full p-4 rounded-t-lg shadow-lg text-white overflow-hidden">
        {/* Background Image & Gradient */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: "url('/assets/ipl/bg_tp.png')",
            filter: "blur(1.2px)",
          }}
        ></div>
        <div
          className={`absolute inset-0 opacity-90   ${
            isFielding
              ? "bg-gradient-to-r from-[#356EA1] via-transparent to-[#356EA1]"
              : isPurple
              ? "bg-gradient-to-r from-[#682B79E5] to-[#5E267500] "
              : isOrange
              ? "bg-gradient-to-r from-[#ED4D29CC] to-[#EE4E2A00] "
              : ""
          }`}
        ></div>

        {/* Card Content */}
        <div className="relative z-10 flex flex-col md:flex-row items-center justify-between w-full gap-4">
          {/* Player Info */}
          <div
            className={`flex flex-row items-center justify-center md:justify-start  w-full md:w-auto flex-1 gap-4`}
          >
            {/* Player Image - Left in mobile */}
            <img
              src={`https://akm-img-a-in.tosshub.com/sites/sports/ipl/resources_live/images/players_img/ipl_2025/${player?.player_id}.png`}
              alt={player?.player_name}
              className={`w-24 md:w-28 shrink-0  mx-3 md:mx-0`}
              onError={(e) => {
                e.target.src =
                  "https://akm-img-a-in.tosshub.com/sites/sports/ipl/resources_live/images/players_img/ipl_2025/0.png";
              }}
            />

            {/* Player Details - Right in mobile */}
            <div className="flex flex-col items-start text-left">
              <h2 className="text-lg font-light">
                {player?.player_name?.split(" ")[0]}
              </h2>
              <h2 className="text-2xl font-bold flex items-center gap-2">
                {player?.player_name?.split(" ").slice(1).join(" ")}
                {isFielding ? (
                  ""
                ) : (
                  <img
                    src={
                      isPurple
                        ? "/assets/ipl/purple_cap.png"
                        : "/assets/ipl/orange_cap.png"
                    }
                    alt={isPurple ? "Purple Cap" : "Orange Cap"}
                    className="w-6 h-6"
                  />
                )}
              </h2>
              <p className="flex items-center gap-2 text-sm mt-1">
                <img
                  src={` https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/${player?.team_short_name?.toLowerCase()}1.png`}
                  alt={player?.team_short_name}
                  className="w-5 h-5  "
                />
                {player?.team_short_name}{" "}
                {isFielding
                  ? ""
                  : `• ${isPurple ? "Purple Cap" : "Orange Cap"}`}
              </p>
            </div>
          </div>

          {/* Player Stats */}
          <div className="grid grid-cols-3 gap-2 md:gap-4 text-center mt-4 md:mt-0">
            <div className="bg-white bg-opacity-20 p-4 rounded-md w-24 h-24">
              <h3 className="text-xl font-bold">
                {isFielding
                  ? player?.most_catches
                  : isPurple
                  ? player?.wickets
                  : player?.runs_scored}
              </h3>
              <p className="text-sm">
                {isFielding ? "Catches" : isPurple ? "Wickets" : "Runs"}
              </p>
            </div>
            <div className="bg-white bg-opacity-20 p-4 rounded-md w-24 h-24">
              <h3 className="text-xl font-bold">{player?.matches_played}</h3>
              <p className="text-sm">Matches</p>
            </div>
            <div className="bg-white bg-opacity-20 p-4 rounded-md w-24 h-24">
              <h3 className="text-xl font-bold">
                {isFielding
                  ? player?.most_dismissals
                  : isPurple
                  ? player?.economy
                  : player?.highest_score}
              </h3>
              <p className="text-sm">
                {isFielding
                  ? "Dismissals"
                  : isPurple
                  ? "Economy Rate"
                  : "Hs. Score"}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopPlayerCard;
